import { useEffect, useState } from "react";
import socket from "../../socket/socket";
import { trackBranch } from "../../services/orderTrackService";

const useBranch = (branchSwitch) => {
  const [branch, setBranch] = useState({});

  /** ---------------- FETCH BRANCH ---------------- **/
  const fetchBranch = async () => {
    try {
      const res = await trackBranch(branchSwitch);

      if (res.data.code === 1) {
        const raw = res.data.data || {};

        setBranch(raw);
      }
    } catch (err) {
      console.error("Fetch Branch Error:", err);
    }
  };

  /** ---------------- SOCKET: ORDER UPDATE ---------------- **/
  useEffect(() => {
    const handleOrderUpdate = (data) => {
      if (!data) return;
      fetchBranch();
    };

    socket.on("merchant:ordersUpdate", handleOrderUpdate);
    return () => socket.off("merchant:ordersUpdate", handleOrderUpdate);
    // eslint-disable-next-line
  }, []);

  /** ---------------- INITIAL LOAD ---------------- **/
  useEffect(() => {
    fetchBranch();
    // eslint-disable-next-line
  }, []);

  return { branch };
};

export default useBranch;
